// extracted by mini-css-extract-plugin
export default {"initial":"GroupIcon_initial__cC+QR","small":"GroupIcon_small__cXQaF","f":"GroupIcon_f__QcXit","l":"GroupIcon_l__19zH5"};